import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Silence the well-known benign "ResizeObserver loop completed with undelivered
// notifications" error. Radix Select/Popover inside a Dialog can trigger it
// during open/close animations. In production this error is a no-op, but in
// CRA/webpack dev the error listener promotes it to a full-screen overlay
// that looks like the entire page went dark, blocking the user from
// interacting with the actual dialog. Ref: https://github.com/WICG/resize-observer/issues/38
// This handler must run BEFORE React renders so react-error-overlay never
// receives the error and never mounts.
const RESIZE_OBSERVER_ERR = "ResizeObserver loop";
window.addEventListener("error", (e) => {
  if (e?.message && e.message.includes(RESIZE_OBSERVER_ERR)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});
window.addEventListener("unhandledrejection", (e) => {
  const msg = (e?.reason && (e.reason.message || String(e.reason))) || "";
  if (msg.includes(RESIZE_OBSERVER_ERR)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});
// react-error-overlay in CRA also listens to `console.error`. Silence that too.
const _consoleError = window.console.error;
window.console.error = (...args) => {
  const first = args[0];
  const asStr = typeof first === "string" ? first : first?.message || "";
  if (asStr.includes(RESIZE_OBSERVER_ERR)) return;
  _consoleError.apply(window.console, args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
